import {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from "react";

interface SignInModalContextType {
  isVisible: boolean;
  openSignInModal: () => void;
  closeSignInModal: () => void;
}

const SignInModalContext = createContext<SignInModalContextType | undefined>(
  undefined,
);

export function SignInModalProvider({ children }: { children: ReactNode }) {
  const [isVisible, setIsVisible] = useState(false);

  const openSignInModal = () => setIsVisible(true);
  const closeSignInModal = () => setIsVisible(false);

  return (
    <SignInModalContext.Provider
      value={{
        isVisible,
        openSignInModal,
        closeSignInModal,
      }}
    >
      {children}
    </SignInModalContext.Provider>
  );
}

export function useSignInModal() {
  const context = useContext(SignInModalContext);
  if (!context) {
    throw new Error(
      "useSignInModal must be used within a SignInModalProvider",
    );
  }
  return context;
}
